module.exports = __webpack_public_path__ + "site/img/12.fedf925f.jpg";